export default {
  FETCH_DATA_PENDING(state) {
    state.loading = true;
  },
  FETCH_DATA_SUCCESS(state, {
    stages, matches, teams, players,
  }) {
    state.loading = false;

    state.stages = stages;
    state.matches = matches;
    state.teams = teams;
    state.players = players;
  },
  SET_STAGE_WEEK(state, { stage, week }) {
    state.stage = stage;
    state.week = week;
  },
};
